import deleteTrashCan from "assets/img/delete-trash-can.svg";
import Button from "components/Button";
import { Card, CardList } from "components/Card";
import CSVDownload2 from "components/CSVDownload2";
import DataTable, { parseSortParam } from "components/DataTable";
import Form from "components/Form";
import Icon from "components/Icon";
import Config from "config";
import { RouteProps } from "containers/App";
import ChainFilter from "containers/ChainFilter";
import CreateBreadcrumb from "containers/CreateBreadcrumb";
import FileUpload from "containers/FileUpload";
import ManageDataPreview from "containers/ManageDataPreview";
import React, {useRef} from "react";
import Popover from "react-popover";
import { connect, ConnectedProps } from "react-redux";
import { State } from "state";
import { buildExportFilename, getTemplateHeaders } from "utils/helpers";
import CSVDownload from "../components/CSVDownload";
import deleteIcon from "../assets/img/Delete.png"
import searchSvg from "../assets/img/filter-data.svg";
import copyIcon from "../assets/img/copyIcon.svg"
import userIcon from "../assets/img/manage_data/user.svg";
import {
  fetchChainUsers,
  exportUsersToStoresByChainId,
  deleteUserToStore,
  deleteAllUserToStoreMappings,
  deleteUserToChainStoreMappings,
  exportUsersStoresMapping,
  getRoles,
  updateUserChainRoleMapping,
  exportAllUserChainMapping,
  deleteChainUserRoleMapping,
  updateUserStoreMapping,
  deleteStoresToUser,
  deleteAllChainRoleMappings,
  CopyUserAssign,
  copyStoreUserMapping,
  saveChainUserRoleFrom,
  saveStoreChainUserRole,
} from "../state/chain_user_role";
import { Chain } from "../interfaces/parentChain";
import { LightThemeTable } from "../components/LightThemeTable";
import ApiLightTable from "../components/ApiTable";
import storeIcon from "assets/img/store.svg";
import Modal from "../components/LightThemeModal";
import doucments from "../assets/img/document.svg";
import {Checkbox, Switch, withStyles} from "@material-ui/core";
import ChainParentFilter from "./ChainParentFilter";
import exportIcon from "assets/img/export.svg";
import RoleFilter from "./RoleFilter";
import FileEditorModal from "components/FileEditorModal";
import {SeverityLevel, ToastService} from "../services/toastService";
import Constants from "helpers/constants";
import Loader from "components/Loader";
import AnimatedDownloadIcon from "components/AnimatedDownloadIcon";
import INFORMATION_ERROR_ICON from "../assets/img/information-error.svg";
import CopyAssignmentModal from "../components/CopyAssignmentModal";
import CopyUserFilter from "./CopyUserFilter";
import AddUsersNotFoundModal from "../components/create-project/AddUsersNotFountModal";

type UserChainRole = {
  userId: number;
  chainId: number;
  currRoleId: number;
  prevRoleId: number;
};

type ChainUserRoles = {
  id: number;
  chain_id: number;
  user_id: number;
  email: string;
  chainName: string;
  firstName: string;
  chain_parent_name: string;
  chain_parent_id: number;
  lastName: string;
  stores: [];
  role: string;
  company: string;
  chain_user_role_id: number;
}[];

const CustomSwitch = withStyles({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: "#fff",
    "&$checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + $track": {
        backgroundColor: "#E5B42F",
        opacity: 1,
        border: "none",
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
  },
  track: {
    borderRadius: 16 / 2,
    border: "1px solid #ccc",
    backgroundColor: "#ccc",
    opacity: 1,
    transition: "background-color 0.3s ease",
  },
  checked: {},
})(Switch);
type ManageMappingDataProps = PropsFromRedux & RouteProps;

export const USER_STORES_PAGE_SIZE = 100;
export const USER_STORES_DEFAULT_SORT = "updated_at.desc";

type UserStore = {
  email: string;
  name: string;
  chainName: string;
  userId: number | null;
};

interface ManageMappingDataState {
  tableData: ChainUserRoles;
  deleteSinglePopoverOpenId: number | null;
  deleteAllPopoverOpenKey: number | string | null;
  deleteChainPopoverOpenKey: number | string | null;
  chainId: number;
  resetTable: boolean;
  email: string | null;
  page: number | null;
  sort: string | null;
  size: number | null;
  selectedUser: UserStore | null;
  stores: any;
  showModal: boolean;
  exportedUserStores: any;
  exportedChainUserRoles: any;
  currentPage: number;
  limit: number;
  editRowId: any | null;
  deleteRowId: number | null;
  roles: any;
  dropdownOptions: any;
  selectedChainRole: UserChainRole | any;
  showWarningModal: boolean;
  statusMessage: string | null;
  onConfirmAction: null;
  selectedStores: any;
  isContinuebtnDisplay: boolean;
  resetKey: number;
  fileEditorOpen: boolean;
  fileEditorFile: File | null;
  fileEditorError: string | null;
  fileEditorOpen2: boolean;
  fileEditorFile2: File | null;
  fileEditorError2: string | null;
  isAwaitingCreation: boolean;
  isAwaitingDelete: boolean;
  isAwaitingExport: boolean;
  isAwaitingExportUserStores: boolean;
  isAwaitingExportChainRoles: boolean;
  storeSelectAll: boolean
  allStores: any
  storesNewlySelected: any,
  storesNewlyUnselected: any,
  originalSelectedStores:any;
  first_name?: string| null;
  last_name?: string| null;
  company?: string| null;
  chain_name?: string| null;
  role_name?: string| null;
  clearSearchTrigger:boolean;
  resetChainFilter:boolean;
  selectedRows: any,
  selectAllActive: boolean,
  copySelectedRows:any
  rowMap: any,
  copyChainAssigmentModal:boolean
  searchCopyingUser:string
  searchCopyUserEmailError:string
  copyUserAssignInfo:CopyUserAssign[] | any
  hasSameChainSelected:boolean
  isCopyContinueBtn:boolean
  copyUsersErrorMsgs:any;
  isAwaitingCopy:boolean;
  isCreateChainRoleModal:boolean;
  createChainUserMessage:string;
  isCreateChainFilter:boolean;
  isResetRoleFilter:boolean
  selectedCreateChain:number;
  selectedCreateRole:number;
  selectedCreateEmail:string;
  showEmailError:boolean;
  createFormError:boolean;
  formStatueErrMsg:string;
  storeUsersInfo:any;
  isStoreUsersModal:boolean;
  storeUserErrors:any
  bulkDeleteMessage:string;
}
interface EditObj {
  userId: number;
  roleId: number;
  chainId: number;
}

const styles = {
  container: { background: "#fff", padding: 10, borderRadius: 10 },
  header: { fontFamily: "Poppins, sans-serif", fontWeight: 700, fontSize: 14, marginBottom: 15 },
  button: (bg: string, color: string, border: string = "none") => ({
    padding: "5px 15px",
    border,
    borderRadius: 4,
    backgroundColor: bg,
    color,
    cursor: "pointer",
    fontSize: 12,
  }),

  modalFooter: { display: "flex", justifyContent: "flex-end", marginTop: 15 },
  confirmFooter: { display: "flex", justifyContent: "center", gap: 20 },
};

const styles2 = {
  container: { background: "#fff", padding: 10, borderRadius: 10 },
  header: { fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: 14, marginBottom: 15 },
  button: (bg: string, color: string, border: string = "none") => ({
    padding: "5px 15px",
    border,
    borderRadius: 4,
    backgroundColor: bg,
    color,
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
  }),
  input: { width: "100%", padding: 8, borderRadius: 16, border: "1px solid #ccc", fontSize: 12 },
  modalFooter: { display: "flex", justifyContent: "flex-end", marginTop: 15 },
  confirmFooter: { display: "flex", justifyContent: "center", gap: 20 },
};


class ManageMappingData extends React.Component<ManageMappingDataProps, ManageMappingDataState> {
  protected CSV_HEADERS = [
    { label: "First Name", key: "first_name" },
    { label: "Last Name", key: "last_name" },
    { label: "Email Address", key: "email" },
    { label: "Store Name", key: "store_name" },
    { label: "Retail Store Number", key: "retail_store_num" },
    { label: "State", key: "state" },
    { label: "Chain Name", key: "chain_name" },
    { label: "Chain Parent Name", key: "chain_parent_name" },
  ];

  protected CSV_HEADERS2 = [
    { label: "Parent Chain Name", key: "parent_chain_name" },
    { label: "Chain Name", key: "chain_name" },
    { label: "First Name", key: "first_name" },
    { label: "Last Name", key: "last_name" },
    { label: "Email Address", key: "email" },
    { label: "Role", key: "role_name" },
  ];

  protected MAX_DELETE_COLUMN_WIDTH = 100;
  protected POPOVER_TRANSITION_MS = 100;
  private lastStoresUsedForSorting: any[] | null = null;
  private sortedStoresList: any[] = [];

  state = {
    tableData: [],
    deleteSinglePopoverOpenId: null,
    deleteAllPopoverOpenKey: null,
    deleteChainPopoverOpenKey: null,
    editChainUserStorePopoverOpenKey: null,
    exportedChainUserRoles: null,
    saveChainUserRole: null,
    deleteChainUserRole: null,
    chainId: -1,
    resetTable: false,
    email: "",
    first_name: "",
    last_name:"",
    company:"",
    chain_name:"",
    role_name:"",
    first_name_sort: "",
    last_name_sort:"",
    company_sort:"",
    name_sort:"",
    role_sort:"",
    page: 0,
    sort: USER_STORES_DEFAULT_SORT,
    size: USER_STORES_PAGE_SIZE,
    showModal: false,
    selectedUser: { name: "", email: "", chainName: "", userId: -1 },
    stores: [],
    exportedUserStores: [],
    currentPage: 0,
    limit: 100,
    editRowId: null,
    deleteRowId: null,
    roles: [],
    dropdownOptions: [],
    selectedChainRole: null,
    showWarningModal: false,
    statusMessage: "",
    onConfirmAction: null,
    selectedStores: [],
    isContinuebtnDisplay: false,
    resetKey: 0,
    fileEditorOpen: false,
    fileEditorFile: null,
    fileEditorError: null,
    fileEditorOpen2: false,
    fileEditorFile2: null,
    fileEditorError2: null,
    isAwaitingCreation: false,
    isAwaitingDelete: false,
    isAwaitingExport: false,
    isAwaitingExportUserStores: false,
    isAwaitingExportChainRoles: false,
    storeSelectAll:false,
    allStores:[],
    storesNewlySelected: [],
    storesNewlyUnselected: [],
    originalSelectedStores:[],
    clearSearchTrigger:false,
    resetChainFilter:false,
    selectAllActive: false,
    selectedRows: [] as Array<string | number>,
    copySelectedRows: [],
    rowMap: {},
    copyChainAssigmentModal:false,
    searchCopyingUser:"",
    searchCopyUserEmailError:"",
    copyUserAssignInfo:[],
    hasSameChainSelected:false,
    isCopyContinueBtn:false,
    copyUsersErrorMsgs:[],
    isAwaitingCopy:false,
    isCreateChainRoleModal:false,
    createChainUserMessage:"",
    isCreateChainFilter:false,
    isResetRoleFilter:false,
    selectedCreateChain:-1,
    selectedCreateRole:-1,
    selectedCreateEmail:"",
    showEmailError:false,
    createFormError:false,
    formStatueErrMsg:"",
    storeUsersInfo:[],
    isStoreUsersModal:false,
    storeUserErrors:[],
    bulkDeleteMessage:"",
  };
  private _isMounted = false;



  public componentDidUpdate(prevProps: ManageMappingDataProps) {
    // when an entry is deleted ensure that we update our table view
    if (
      prevProps.chinsUserRoles &&
      this.props.chinsUserRoles &&
      prevProps.chinsUserRoles.length !== this.props.chinsUserRoles.length
    ) {
      this.updateTableData();
    }
    if (prevProps.roles && this.props.roles && prevProps.roles.length !== this.props.roles.length) {
      this.updateRoles();
    }
    if (
      this.props.copyAssignUserError &&
      this.props.copyAssignUserError.length > 0 &&
      prevProps.copyAssignUserError !== this.props.copyAssignUserError
    ) {
      this.setState({
        copyUsersErrorMsgs: this.props.copyAssignUserError,
      });
    }
  }

  public componentDidMount() {
    this._isMounted = true;
    this.updateTableData();
    const { chainId, email, page, size, sort } = this.state;
    this.props
      .fetchChainUsers({ chainId, page: page, size: size, sort: sort, email: email })
      .then(() => {
        this.updateTableData();
      });
    this.props.getRoles();
    this.updateRoles();
  }
  public displayStores(
    stores: [],
    userName: string,
    email: string,
    chainName: string,
    userId: number
  ) {
    this.setState({ storeSelectAll:false });
    this.toggleDisplayPopoverStores(stores, userName, email, chainName, userId);
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  public toggleDeleteSinglePopoverOpenId(id: number) {
    this.setState({
      deleteSinglePopoverOpenId: this.state.deleteSinglePopoverOpenId ? null : id,
    });
  }

  public toggleDisplayPopoverStores(
    stores: [],
    userName: string,
    email: string,
    chainName: string,
    userId: number
  ) {
    // Store original assigned list BEFORE any changes
    const originalSelected = stores
      .filter((s:any) => s.is_assigned_to_user)
      .map((s:any) => Number(s.store_id));
    const storeSelectAll =
      stores.length > 0 &&
      stores.every((s: any) => s.is_assigned_to_user ===1);
    this.setState({
      showModal: true,
      selectedUser: { name: userName, email: email, chainName: chainName, userId: userId },
      stores: stores,
      originalSelectedStores: originalSelected,
      storesNewlySelected: [],
      storesNewlyUnselected: [],
      storeSelectAll: storeSelectAll
    });
  }

  public toggleDeleteChainPopoverOpenId(key: string) {
    this.setState({
      deleteChainPopoverOpenKey: this.state.deleteChainPopoverOpenKey ? null : key,
    });
  }
  public handleResetDropdown = () => {
    this.setState((prev: any) => ({
      resetKey: prev.resetKey + 1,
    }));
  };

  public handleDelete(selectId: number,chainName:string) {
    this.setState({
      showWarningModal: true,
      statusMessage: `Are you sure to delete chain role mapping with ${chainName}?`,
      deleteRowId: selectId,
      isContinuebtnDisplay: true,
    });
  }

  public handleConfirm = () => {
    this.setState({ isAwaitingDelete: true });
    this.props.deleteChainUserRoleMapping(this.state.deleteRowId).then(() => {
      this.reloadTable(true);
      this.setState({ deleteRowId: null, isContinuebtnDisplay: false, isAwaitingDelete: false, showWarningModal: false });
    });
  };

  public toggleDeleteAllPopoverOpenId(key: string) {
    this.setState({
      deleteAllPopoverOpenKey: this.state.deleteAllPopoverOpenKey ? null : key,
    });
  }

  public handleDeleteChain(userId: number) {
    const { chainId } = this.state;

    this.props.deleteUserToChainStoreMappings(userId, chainId);
  }

  public handleDeleteAll(userId: number) {
    if (userId >= 0) {
      this.props.deleteAllUserToStoreMappings(userId).then(() => {
        this.setState({
          showModal: false,
          selectedUser: { name: "", email: "", chainName: "", userId: null },
          selectedStores: [],
          stores: [],
        });
        this.reloadTable(true);
      });
    }
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: e.target.value });
  };

  public handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    const { chainId } = this.state;
    // reset form and inputs
    this.setState({
      email: "",
      page: 0,
      size: USER_STORES_PAGE_SIZE,
      sort: USER_STORES_DEFAULT_SORT,
    });
    this.props
      .fetchChainUsers({
        chainId,
        page: 0,
        size: USER_STORES_PAGE_SIZE,
        sort: USER_STORES_DEFAULT_SORT,
      })
      .then(() => {
        this.setState({ resetTable: true });
        this.updateTableData();
        this.setState({
          resetTable: false,
          page: 0,
          size: USER_STORES_PAGE_SIZE,
          sort: USER_STORES_DEFAULT_SORT,
        });
      });
    this.props
      .fetchChainUsers({
        chainId,
        page: 0,
        size: USER_STORES_PAGE_SIZE,
        sort: USER_STORES_DEFAULT_SORT,
        email: "",
      })
      .then(() => {
        this.setState({ resetTable: true });
        this.updateTableData();
        this.setState({
          resetTable: false,
          page: 0,
          size: USER_STORES_PAGE_SIZE,
          sort: USER_STORES_DEFAULT_SORT,
        });
      });
  };

  public handleSubmit = (e: React.MouseEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { chainId, email, page, size, sort } = this.state;
    this.props
      .fetchChainUsers({ chainId, page: page, size: size, sort: sort, email: email })
      .then(() => {
        this.updateTableData();
      });
  };

  toTitleCase = (str: string) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  public updateTableData(id?: number) {
    if (!this._isMounted) return;

    const { chinsUserRoles = [] } = this.props;

    const formattedTableData = chinsUserRoles.map((item: any) => ({
      ...item,
      first_name: this.toTitleCase(item.first_name),
      last_name: this.toTitleCase(item.last_name),
      company: this.toTitleCase(item.company),
    }));
    const isEmpty =
      id === undefined || id === null || id === -1;


    const finalData = isEmpty
      ? formattedTableData
      : formattedTableData.filter(
        (item: any) => Number(item.chain_id) === Number(id)
      );

    if (this._isMounted) {
      this.setState(prev => ({
        tableData: finalData,
        selectedRows: prev.selectAllActive ? [] : prev.selectedRows,
      }));
    }
  }

  public updateRoles() {
    const { roles } = this.props;

    this.setState({
      dropdownOptions: roles,
    });
  }

  handleCheckboxChange = (row: any, evt: any) => {
    const checked = typeof evt === "boolean" ? evt : !!evt?.target?.checked;

    const storeId = Number(row.store_id);

    this.setState((prevState) => {
      // Update store list
      // const updatedStores = prevState.stores.map((s: any) =>
      //   Number(s.store_id) === storeId ? { ...s, is_assigned_to_user: checked } : s
      // );
      // Keep the same array reference so the modal table does not reset to page 1.
      const updatedStores = prevState.stores;
      const targetStore = updatedStores.find((s: any) => Number(s.store_id) === storeId);
      if (targetStore) {
        targetStore.is_assigned_to_user = checked;
      }

      // Build updated selected list
      const updatedSelected = updatedStores
        .filter((s: any) => s.is_assigned_to_user)
        .map((s: any) => Number(s.store_id));

      // ---------------------------
      //  CRITICAL CHANGE DETECTION LOGIC
      // Compare CURRENT selected vs ORIGINAL selected
      // ---------------------------

      const newlySelectedStoreIds = updatedSelected.filter(
        (id:number) => !prevState.originalSelectedStores.includes(id)
      );

      // Convert store_ids → retail_store_num
      const newlySelected = newlySelectedStoreIds.map((id:number) => {
        const store:any = this.state.stores.find((s:any) => Number(s.store_id) === Number(id));
        return store ? store.retail_store_num : null;
      }).filter(Boolean); // remove nulls

      const newlyUnselected = prevState.originalSelectedStores.filter(
        (id:number) => !updatedSelected.includes(id)
      );

      return {
        stores: updatedStores,
        selectedStores: updatedSelected,
        storesNewlySelected: newlySelected,
        storesNewlyUnselected: newlyUnselected,
      };
    });
  };

  handleEdit = (editObj: any) => {
    this.setState({ editRowId: editObj });
    const editData = editObj.split("_");
    this.setState({
      selectedChainRole: {
        userId: editData[0],
        chainId: editData[2],
        prevRoleId: editData[1],
        currRoleId: editData[1],
      },
    });
  };

  handleSave = (selectedChainRole: any) => {
    this.props
      .updateUserChainRoleMapping({
        userId: selectedChainRole.userId,
        chainId: selectedChainRole.chainId,
        currRoleId: selectedChainRole.currRoleId,
        prevRoleId: selectedChainRole.prevRoleId,
      })
      .then(() => {
        this.setState({ editRowId: null });
        this.reloadTable(true);
      });
  };

  reloadTable = (preservePagination: boolean = false) => {
    const { chainId, page, size, sort } = this.state;
    const nextPage = preservePagination
      ? (page ?? 0)
      : 0;
    const nextSize = preservePagination
      ? (this.props.pageSize ?? size ?? USER_STORES_PAGE_SIZE)
      : USER_STORES_PAGE_SIZE;
    const nextSort = preservePagination ? (sort || USER_STORES_DEFAULT_SORT) : USER_STORES_DEFAULT_SORT;

    const searchParams = this.getSearchParams();
    // this.setState({ clearSearchTrigger: true,resetChainFilter: false });
    // Don't clear search trigger or search fields - preserve current filters
    this.props
      .fetchChainUsers({
        chainId,
        page: nextPage,
        size: nextSize,
        sort: nextSort,
        ...searchParams,
      })
      .then(() => {
        this.setState({ resetTable: true });
        this.updateTableData(chainId);
        this.setState({
          resetTable: false,
          page: nextPage,
          size: nextSize,
          sort: nextSort,
          // clearSearchTrigger: false,
          // email: "",
          // first_name: "",
          // last_name:"",
          // company:"",
          // chain_name:"",
          // role_name:"",
          // // chainId:-1,
          // // resetChainFilter:false,
          // Don't reset search fields - keep current filters
          selectAllActive: false,
          selectedRows: [],
        });
      });
  };

  handleGrantAccess = async () => {
    if(this.state.storeSelectAll){
      this.setState({ isAwaitingCreation: true });
      this.props.updateUserStoreMapping({ rows: this.state.allStores }).then(() => {
        this.setState({
          showModal: false,
          selectedUser: { name: "", email: "", chainName: "", userId: null },
          selectedStores: [],
          stores: [],
          storeSelectAll:false,
          allStores:[],
          isAwaitingCreation:false
        });
        this.reloadTable();
      }).catch(e=>{
        console.log("error occurred, ",e)
        this.setState({ isAwaitingCreation: false });
      });
    }else{
      const { storesNewlyUnselected, storesNewlySelected, selectedUser } = this.state;

      const promises = [];

      // 1️⃣ If stores are unselected → delete them
      if (storesNewlyUnselected.length > 0) {
        promises.push(this.props.deleteStoresToUser(storesNewlyUnselected, selectedUser.userId));
      }

      // 2️⃣ If stores are newly selected → map them
      if (storesNewlySelected.length > 0) {
        const selectedStoresInfo = storesNewlySelected.map((eachValue) => ({
          email: selectedUser.email,
          retail_store_number: eachValue,
          chain_name: selectedUser.chainName,
        }));

        if (selectedStoresInfo.length > 0) {
          this.setState({ isAwaitingCreation: true });
          promises.push(this.props.updateUserStoreMapping({ rows: selectedStoresInfo }));
        } else {
          this.setState({
            showWarningModal: true,
            statusMessage: "Please select at least one store to grant access",
            isContinuebtnDisplay: false,
          });
          return;
        }
      }
      try {
        this.setState({ isAwaitingCreation: true });
        await Promise.all(promises);
        this.setState({
          showModal: false,
          selectedUser: { name: "", email: "", chainName: "", userId: null },
          selectedStores: [],
          stores: [],
          isAwaitingCreation: false,
        });

        this.reloadTable();
      } catch (err) {
        this.setState({ isAwaitingCreation: false });
        console.error("Error updating stores:", err);
      }
    }
  };

  handleExportAllUserStores = async () => {
    this.setState({ isAwaitingExportUserStores: true });
    try {
      const data: any = await this.props.exportUsersStoresMapping(Math.max(this.state.chainId, -1));
      this.setState({ exportedUserStores: data || [] });
    } catch (error) {
      console.error("Error exporting CSV:", error);
    } finally {
      this.setState({ isAwaitingExportUserStores: false });
    }
  };

  handleExportAllStoreMappings = async () => {
    this.setState({ isAwaitingExportChainRoles: true });
    try {
      const data: any = await this.props.exportAllUserChainMapping(Math.max(this.state.chainId, -1));
      this.setState({ exportedChainUserRoles: data || [] });
    } catch (error) {
      console.error("Error exporting CSV:", error);
    } finally {
      this.setState({ isAwaitingExportChainRoles: false });
    }
  };
  /* ----------------------------------------------------
      SINGLE ROW SELECT HANDLER
  -----------------------------------------------------*/
  handleRowSelect = (row: any) => {
    if(this.state.copyUsersErrorMsgs.length>0){
      this.setState({copyUsersErrorMsgs:[]})
    }
    const rowId = row?.chain_user_role_id;
    if (rowId === undefined || rowId === null) return;

    this.setState(prev => {

      const alreadySelected = prev.selectedRows.includes(rowId);

      const updatedSelection = alreadySelected
        ? prev.selectedRows.filter((id: any) => id !== rowId) // unselect one
        : [...prev.selectedRows, rowId];                     // select one
      const chainCountMap: Record<number, number> = {};

      updatedSelection.forEach((id: number) => {
        const rowData = (this.state.tableData as any[]).find(
          item => item.chain_user_role_id === id
        );
        if (!rowData) return;

        const chainId = rowData.chain_id;
        chainCountMap[chainId] = (chainCountMap[chainId] || 0) + 1;
      });

      // 3️SAME CHAIN EXISTS ONLY IF COUNT > 1
      const isSameChainAlreadySelected = Object.values(chainCountMap).some(
        count => count > 1
      );



      const updatedRowMap = { ...prev.rowMap };

      if (alreadySelected) {
        delete updatedRowMap[rowId];
      } else {
        updatedRowMap[rowId] = row;
      }

      // 3️Build FINAL copySelectedRows (ONLY FINAL SELECTED, MAX 10)
      // const updatedCopySelectedRows = updatedSelection
      //   .map((id: any) =>
      //     (this.state.tableData as any[]).find(
      //       item => item.chain_user_role_id === id
      //     )
      //   )
      //   .filter(Boolean)
      //   .slice(0, 10);
      const updatedCopySelectedRows = Object.values(updatedRowMap).slice(0, 10);
      return {
        selectedRows: updatedSelection,
        rowMap: updatedRowMap,
        copySelectedRows: updatedCopySelectedRows,
        // If unselecting while select-all is active → disable selectAll
        selectAllActive: prev.selectAllActive && !alreadySelected ? false : prev.selectAllActive,
        hasSameChainSelected:isSameChainAlreadySelected,
        bulkDeleteMessage: ""
      };
    });
  };

  displayCreateChainUserMapping = () =>{
      this.setState(
        {
          isCreateChainRoleModal:true,
          isCopyContinueBtn:true,
          selectedCreateChain:-1,
          selectedCreateRole:-1,
          selectedCreateEmail:""
        })
  }

  // handleSelectAll = () => {
  //   const { selectAllActive } = this.state;
  //
  //   this.setState(prev => {
  //     if (!selectAllActive) {
  //       return {
  //         selectAllActive: true,
  //         selectedRows: [],  // store exceptions only (none right now)
  //       };
  //     }
  //
  //     return {
  //       selectAllActive: false,
  //       selectedRows: [],
  //     };
  //   });
  // };

  handleSelectAll = () => {
    const { selectAllActive, tableData } = this.state;
    const {totalCount} = this.props

    this.setState(prev => {
      // If user clicks Select All but there’s <2 records
      if (!selectAllActive && (tableData.length < 2 ||  totalCount && totalCount < 2)) {
        const singleRow = (tableData as any[])[0];
        return {
          selectAllActive: true,
          selectedRows: singleRow ? [singleRow] : [],
          copySelectedRows: singleRow ? [singleRow] : [],
          hasSameChainSelected: false,
          bulkDeleteMessage: ""
        };
      }

      // Normal toggle logic
      if (!selectAllActive) {
        let hasSameChainSelected = false;
        if (tableData.length > 2) {
          const chainCountMap: Record<number, number> = {};
          (tableData as any[]).forEach(row => {
            const chainId = row.chain_id;
            chainCountMap[chainId] = (chainCountMap[chainId] || 0) + 1;
          });
          hasSameChainSelected = Object.values(chainCountMap).some(count => count > 1);
        }
        return {
          selectAllActive: true,
          selectedRows: [],  // store exceptions only (none right now)
          copySelectedRows: [],
          hasSameChainSelected: false,
          bulkDeleteMessage: ""
        };
      }

      return {
        selectAllActive: false,
        selectedRows: [],
        copySelectedRows: [],
        hasSameChainSelected: false,
        bulkDeleteMessage: ""
      };
    });
  };


  handleDeleteAllChainRole = async () => {
    this.setState({ isAwaitingExport: true });
    try {
      if(this.state.hasSameChainSelected){
        this.setState({ hasSameChainSelected: false});
      }
      const {selectedRows,selectAllActive,chainId, tableData} = this.state;
      const currentEmail = String(this.props.authUser?.email || "").trim().toLowerCase();
      const isSelf = (row: any) => String(row?.email || "").trim().toLowerCase() === currentEmail;

      let rowsToCheck: any[];
      if (!selectAllActive) {
        const roleIds = (selectedRows || []).map((r: any) => typeof r === "object" ? r?.chain_user_role_id : r).filter(Boolean);
        rowsToCheck = (tableData as any[]).filter((r: any) => roleIds.includes(r.chain_user_role_id));
      } else {
        const totalPages = Math.max(1, Math.ceil(Number(this.props.totalCount || 0) / USER_STORES_PAGE_SIZE));
        const baseParams = { chainId, size: USER_STORES_PAGE_SIZE, sort: this.state.sort || USER_STORES_DEFAULT_SORT, ...this.getSearchParams() };
        rowsToCheck = [];
        for (let p = 0; p < totalPages; p++) {
          await this.props.fetchChainUsers({ ...baseParams, page: p });
          rowsToCheck.push(...(Array.isArray(this.props.chinsUserRoles) ? this.props.chinsUserRoles : []));
        }
        rowsToCheck = [...new Map(rowsToCheck.map(r => [r.chain_user_role_id, r])).values()];
      }

      const hasSelf = rowsToCheck.some(isSelf);
      const deletableIds = rowsToCheck.filter(r => !isSelf(r)).map(r => Number(r.chain_user_role_id));
      this.setState({ bulkDeleteMessage: hasSelf ? "You cannot delete yourself" : "" });

      if (deletableIds.length > 0) {
        await this.props.deleteAllChainRoleMappings({ chainRoleIds: deletableIds, isSelectAll: false, chainId });
      }
      this.reloadTable(true);
      this.setState({ isAwaitingExport: false, selectedRows: [], selectAllActive: false });
    } catch (error) {
      this.setState({ isAwaitingExport: false });
      console.error("Error exporting CSV:", error);
    }
  };

  handleCopyAllChainRole = async () =>{
    this.setState({copyChainAssigmentModal:true,isCopyContinueBtn:true})
  }

  handleSaveChainUser = async () => {
    this.setState({ isAwaitingCopy: true });
    const {selectedCreateChain,selectedCreateRole,selectedCreateEmail} = this.state
    if(selectedCreateChain>=0 && selectedCreateRole>=0 && selectedCreateEmail){
      this.props.saveChainUserRoleFrom({chain_id:selectedCreateChain,role_id:selectedCreateRole,email:selectedCreateEmail}).then(()=>{
        this.setState({ isAwaitingCopy: false });
        if (this.props.saveChainUserRoleErrorMsg) {
          this.setState({formStatueErrMsg:this.props.saveChainUserRoleErrorMsg})
          return
        }
        this.reloadTable();
        this.setState({ isCreateChainRoleModal: false,formStatueErrMsg:"", selectedCreateChain:-1,
          selectedCreateRole:-1, selectedCreateEmail:"" })
      }).catch((e)=>{
        this.setState({ isAwaitingCopy: false });
      })
    }
  }


  handleSaveStoreChainUser = async (storeUserChain:any) => {
    this.setState({ isAwaitingCopy: true, storeUserErrors: [] });
    if(storeUserChain.length>=0 ){
      this.props.saveStoreChainUserRole({storeUserChains:storeUserChain}).then(()=>{
        this.setState({ isAwaitingCopy: false });
        if (this.props.storeUserChainRoleError && this.props.storeUserChainRoleError.length>0) {
          this.setState({storeUserErrors:this.props.storeUserChainRoleError})
          return
        }
        this.reloadTable();
        this.setState({ storeUserErrors: [],isStoreUsersModal:false })
      }).catch((e)=>{
        this.setState({ isAwaitingCopy: false });
      })
    }
  }


  public renderForm() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Group title="Search">
          <Form.Input
            type="text"
            placeholder="Email"
            data-qa="store-email-field"
            value={this.state.email}
            name="email"
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.ButtonGroup>
          <Form.CancelButton onClick={this.handleClear} data-qa="clear-button">
            Clear
          </Form.CancelButton>
          <Form.ConfirmButton data-qa="search-button">Search</Form.ConfirmButton>
        </Form.ButtonGroup>
      </Form>
    );
  }

  public handleUploadError = (error: any, uploadedFile: File) => {
    // Extract error message from different possible error formats
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Upload failed. Please review and correct the file.";

    this.setState({
      fileEditorOpen: true,
      fileEditorFile: uploadedFile,
      fileEditorError: errorMessage,
    });
  };

  public handleFileEditorClose = () => {
    this.setState({
      fileEditorOpen: false,
      fileEditorFile: null,
      fileEditorError: null,
    });
  };

  public handleFileEditorSuccess = async () => {
    // Refresh the store list after successful edit upload
    this._isMounted = true;
    this.updateTableData();
    const { chainId, email, page, size, sort } = this.state;
    this.reloadTable()
    // this.props
    //   .fetchChainUsers({ chainId, page: page, size: size, sort: sort, email: email })
    //   .then(() => {
    //     this.updateTableData();
    //   });
    this.props.getRoles();
    this.updateRoles();
    // this.props.fetchChainUsers();

    // this.updateTableData();
    this.handleFileEditorClose();
    const {fileUploadedData} = this.props
    console.log("Test of data",fileUploadedData['chainInfo']?.['chainUserMapping'])
    if(fileUploadedData['chainInfo']?.['chainUserMapping'] &&
      fileUploadedData['chainInfo']?.['chainUserMapping'].length>0){
      this.setState({isStoreUsersModal:true,storeUsersInfo:fileUploadedData['chainInfo']?.['chainUserMapping']})
    }
  };

  public handleUploadError2 = (error: any, uploadedFile: File) => {
    // Extract error message from different possible error formats

    console.error("handleUploadError triggers", error);

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Upload failed. Please review and correct the file.";

    this.setState({
      fileEditorOpen2: true,
      fileEditorFile2: uploadedFile,
      fileEditorError2: errorMessage,
    });
  };

  public handleFileEditorClose2 = () => {
    this.setState({
      fileEditorOpen2: false,
      fileEditorFile2: null,
      fileEditorError2: null,
    });
  };

  public handleFileEditorSuccess2 = async () => {
    const { chainId } = this.state;
    this.props
      .fetchChainUsers(chainId, {
        page: 0,
        size: USER_STORES_PAGE_SIZE,
        sort: USER_STORES_DEFAULT_SORT,
      })
      .then(() => {
        this.setState({ resetTable: true});
        this.updateTableData();
        this.handleResetDropdown();
        this.setState({
          resetTable: false,
          page: 0,
          size: USER_STORES_PAGE_SIZE,
          sort: USER_STORES_DEFAULT_SORT,
        });
      });

    // this.updateTableData();
    this.handleFileEditorClose2();
  };

  handleHeaderToggle = (checked: boolean) => {
    if (!checked) {
      this.setState({ storeSelectAll: false, allStores: [] });
      return;
    }

    const hasStores = Array.isArray(this.state.stores) && this.state.stores.length > 0;
    const selectedStoresInfo = hasStores
      ? [
          {
            email: this.state.selectedUser.email,
            retail_store_number: "ALL",
            chain_name: this.state.selectedUser.chainName,
          },
        ]
      : [];

    this.setState({ storeSelectAll: true, allStores: selectedStoresInfo });
  };

  getSearchParams = () => {
    const {
      email,
      first_name,
      last_name,
      company,
      chain_name,
      role_name
    } = this.state;

    const searchFields = {
      email,
      first_name,
      last_name,
      company,
      chain_name,
      role_name,
    };

    const filtered: any = {};
    Object.entries(searchFields).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        filtered[key] = value;
      }
    });

    return filtered;
  };
  validateEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  handleSwitchUser = (user:any) => {
    this.setState(prev => {
      const alreadySelected = prev.copyUserAssignInfo.some(
        (u: any) => u.email === user.email
      );

      if (alreadySelected) {
        return null; // no state update
      }

      return {
        copyUserAssignInfo: [...prev.copyUserAssignInfo, user]
      };
    });
    // const { searchCopyingUser } = this.state;
    //
    // if (!this.validateEmail(searchCopyingUser)) {
    //   this.setState({ searchCopyUserEmailError: "Please enter a valid email address" });
    //   return;
    // }
    //
    // this.props.getCopyStoreAssignUserInfo({email:searchCopyingUser}).then(()=>{
    //   if(this.props.copyAssignUserError){
    //     let errorMessage =
    //       this.props.copyAssignUserError === 409
    //         ? "Email Address is does not exists. Please create it"
    //         : "An error occurred.";
    //     this.setState({ searchCopyUserEmailError:errorMessage });
    //   }
    //   if(this.props.copyAssignUser){
    //     this.setState({copyUserAssignInfo:this.props.copyAssignUser})
    //     console.log("Copy User Info=>",this.state.copyUserAssignInfo)
    //   }
    //
    // })
    //
    // this.setState({ searchCopyUserEmailError: "" });
    //
    // // Proceed with search logic
    // console.log("Valid email:", searchCopyingUser);
  };


  removeUserSelect = (user:any) =>{
    if(this.state.copyUsersErrorMsgs.length>0){
      this.setState({copyUsersErrorMsgs:[]})
    }
    const emailToRemove = user?.email;
    if (!emailToRemove) return;
    this.setState((prevState: any) => ({
      copyUserAssignInfo: prevState.copyUserAssignInfo.filter(
        (u: any) => u.email !== emailToRemove
      ),
    }));
  }

  handleCopyStoreAssignment = async () =>{
    this.setState({ isAwaitingCopy: true,copyUsersErrorMsgs:[] });
      try {
        const { copySelectedRows, copyUserAssignInfo } = this.state;
        const mappedResult = copyUserAssignInfo.flatMap((user: any) =>
          copySelectedRows.map((chainUserId: any) => ({
            chain_user_id: chainUserId.chain_user_role_id,
            chain_name:chainUserId.chain_name,
            email:user.email,
            role:chainUserId.role_name
          }))
        );
        this.props.copyStoreUserMapping({allMappings:mappedResult}).then((response)=>{
          this.setState({isAwaitingCopy:false})
          if(this.state.copyUsersErrorMsgs.length==0){
            this.setState({copyChainAssigmentModal:false,copySelectedRows:[],copyUserAssignInfo:[],selectedRows:[]})
            this.updateTableData();
            this.handleResetDropdown();
            this.reloadTable()
          }
        })
      } catch (e) {
        this.setState({isAwaitingCopy:false})
        console.error(e);
      }

    // this.setState({isAwaitingExport:true})
    // const { copySelectedRows, copyUserAssignInfo } = this.state;
    // const mappedResult = copyUserAssignInfo.flatMap((user: any) =>
    //   copySelectedRows.map((chainUserId: any) => ({
    //     chain_user_id: chainUserId.chain_user_role_id,
    //     chain_name:chainUserId.chain_name,
    //     email:user.email,
    //     role:chainUserId.role_name
    //   }))
    // );
    // this.props.copyStoreUserMapping({allMappings:mappedResult}).then(()=>{
    //   this.setState({isAwaitingExport:false,copyChainAssigmentModal:false})
    //
    // }).catch((e)=>{
    //   this.setState({isAwaitingExport:false})
    //   console.log("Error=>",e)
    // })
    // console.log("Errors==>",this.props.copyAssignUserError)

  }

  // --- Add these handlers ---
  handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    this.setState({ selectedCreateEmail: value });
  };

  handleEmailBlur = () => {
    const { selectedCreateEmail } = this.state;

    // Simple but effective email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    this.setState({
      showEmailError: selectedCreateEmail.length > 0 && !emailRegex.test(selectedCreateEmail),
    });
  };

  public render() {
    const {
      chinsUserRoles,
      loading,
      exportContent,
      totalPages,
      exportedUserStores,
      currentPage,
      pageSize,
      totalCount,
      exportedChainUserRole,
      chainUserRoleLoader,
      authUser,
      page,
      copyAssignUser,
      copyAssignUserError,
      fileUploadedData,
      storeUserChainRoleError
    } = this.props;
    const userRole = authUser?.role;
    const isMobile = window.innerWidth <= 768;
    const {
      resetTable,
      fileEditorOpen,
      fileEditorFile,
      fileEditorError,
      fileEditorOpen2,
      fileEditorFile2,
      fileEditorError2,
    } = this.state;

    let label = "USER ROLE CHAIN";
    let label2 = "User to Store Manage Mapping";
    let secondHeaders = [
      {},
      {
        chainName: "Store Number",
        projectName: "File Name",
        projectType: "File Type",
        timezone: "Status",
        projectDeadline: "Store Deadline",
        season: "---",
        year: "---",
      },
    ];
    const { editRowId } = this.state;
    const contributorViewerRoles = [Constants.VIEWER, Constants.CONTRIBUTER, Constants.CONTRIBUTER_NO_PSA_ACCESS, Constants.VIEWER_NO_PSA_ACCESS];
    const columns = [
      {
        field: "checkbox",
        header: "", // empty header for the checkbox column
        minWidth: 40,
        maxWidth: 40,
        sortable: false,
        searchable: false,
      },
      { field: "first_name", header: "First Name",sortable: true, searchable: true },
      { field: "last_name", header: "Last Name",sortable: true, searchable: true },
      { field: "email", header: "Email Address",sortable: true, searchable: true },
      { field: "company", header: "Company Representing",sortable: true, searchable: true },
      { field: "chain_name", header: "Chain",sortable: true, searchable: true },
      {
        field: "role_name",
        header: "Role Mapping",
        formatter: (_: any, row: any) => {
          const isEditing = editRowId === `${row.user_id}_${row.role_id}_${row.chain_id}`;
          return (
            <div style={{zIndex: 9999}}>
              {isEditing ? (
                <RoleFilter
                  value={row.role_id}
                  options={this.state.dropdownOptions}
                  onChange={({ id }) =>
                    this.setState({
                      selectedChainRole: {
                        userId: row.user_id,
                        chainId: row.chain_id,
                        prevRoleId: row.role_id,
                        currRoleId: id,
                      },
                    })
                  }
                  isSearchable
                />
              ) : (
                row.role_name
              )}
            </div>
          );
        },
      },
      {
        field: "actions",
        header: "",
        formatter: (_: any, row: any) => {
          const isEditing = editRowId === `${row.user_id}_${row.role_id}_${row.chain_id}`;
          const canManageRow = userRole === Constants.AB_SYSTEM_ADMIN || contributorViewerRoles.includes(row?.role_name);
          const noAccess = canManageRow ? undefined : "Only Contributor/Viewer users can be modified";
          return (
            <div style={{width: "max-content"}}>
              <button 
                onClick={() => 
                  canManageRow && this.displayStores(
                    row?.stores, 
                    row?.first_name, 
                    row?.email, 
                    row?.chain_name, 
                    row?.user_id
                  )
                } disabled={!canManageRow} title={noAccess} 
                style={{ background: "none", border: "none", cursor: canManageRow ? "pointer" : "not-allowed", opacity: canManageRow ? 1 : 0.35 }}
              >
                <img src={require("../assets/img/stores.png")} alt="Store" />
              </button>
              {isEditing ? (
                <button 
                  onClick={() => canManageRow && this.handleSave(this.state.selectedChainRole)} disabled={!canManageRow} title={noAccess} 
                  style={{ background: "none", border: "none", cursor: canManageRow ? "pointer" : "not-allowed", opacity: canManageRow ? 1 : 0.35 }}
                >
                  <img src={require("../assets/img/save.png")} alt="Save" />
                </button>
              ) : (
                <button 
                  onClick={() => canManageRow && this.handleEdit(`${row.user_id}_${row.role_id}_${row.chain_id}`)} disabled={!canManageRow} title={noAccess} 
                  style={{ background: "none", border: "none", cursor: canManageRow ? "pointer" : "not-allowed", opacity: canManageRow ? 1 : 0.35 }}
                >
                  <img src={require("../assets/img/Edit.png")} alt="Edit" />
                </button>
              )}
              <button 
                onClick={() => canManageRow && this.handleDelete(row.chain_user_role_id,row.chain_name)} disabled={!canManageRow} title={canManageRow ? undefined : "Only Contributor/Viewer users can be deleted"}
                style={{ background: "none", border: "none", cursor: canManageRow ? "pointer" : "not-allowed", opacity: canManageRow ? 1 : 0.35 }}
              >
                <img src={require("../assets/img/Delete.png")} alt="Delete" />
              </button>
            </div>
          );
        },
      }
    ];
    const storeColumns = [
      { field: "retail_store_num", header: "Store Number" },
      { field: "state", header: "State" },
      {
        field: "actions",
        header: "",
        formatter: (_: any, row: any) => (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <input
              type="checkbox"
              checked={row.is_assigned_to_user}
              onChange={(e) => this.handleCheckboxChange(row, e.target.checked)}
              disabled={this.state.storeSelectAll}
              className={`custom-checkbox ${this.state.storeSelectAll ? "checkbox-disabled" : ""}`}
            />
          </div>
        ),
      },
    ];

    if (this.lastStoresUsedForSorting !== this.state.stores) {
      this.lastStoresUsedForSorting = this.state.stores;
      this.sortedStoresList = Array.isArray(this.state.stores)
      ? [...this.state.stores].sort((a: any, b: any) => {
          const aValue = String(a?.retail_store_num ?? "").trim();
          const bValue = String(b?.retail_store_num ?? "").trim();
          const aIsNumeric = /^\d+$/.test(aValue);
          const bIsNumeric = /^\d+$/.test(bValue);
          if (aIsNumeric && bIsNumeric) return Number(aValue) - Number(bValue) || aValue.localeCompare(bValue, undefined, { numeric: true, sensitivity: "base" });
          if (aIsNumeric !== bIsNumeric) return aIsNumeric ? -1 : 1;
          return aValue.localeCompare(bValue, undefined, { sensitivity: "base" });
        })
      : [];
    }
    const sortedStores = this.sortedStoresList;

    const getFullName = (firstName:string,lastName:string)=>{
      return `${firstName} ${lastName}`
    }

    return (
      <>
      <style>{`
        .manage-mapping-data > div > div > table {
          margin-bottom: 250px;
        }
    `}</style>
      <section style={{ height: "100%" }} className="manage-data-container">
        <CreateBreadcrumb
          crumbs={{
            crumbs: [
              {
                to: "/manage-all-data",
                crumb: "VIEW ALL DATA",
                dataQa: "view-all-data-link",
              },
            ],
          }}
        />
        <div style={{ height: "100%", overflow: "visible" }} className="manage-data-body">
          <div className="chain-user-upload">
            <div className="upload-section" style={{flexWrap: "wrap"}}>
              <h4>User Store Data</h4>
              <div>
                <CSVDownload
                  data={[]}
                  headers={getTemplateHeaders(label2)}
                  filename={buildExportFilename("csv", `${label2}-template`)}
                >
                  <div className="file-upload-header">Download CSV Template</div>
                </CSVDownload>
              </div>
              <FileUpload
                prefix={"USER2STORE"}
                url={`${Config.API_SERVICE_URL}/api/users-stores`}
                label={""}
                dataQa={"user-store-mapping-file-upload"}
                afterUploadFunction={() => {
                  const {fileUploadedData} = this.props
                  console.log("Test of data",fileUploadedData['chainInfo']?.['chainUserMapping'])
                  if(fileUploadedData['chainInfo']?.['chainUserMapping'] &&
                    fileUploadedData['chainInfo']?.['chainUserMapping'].length>0){
                    this.setState({isStoreUsersModal:true,storeUsersInfo:fileUploadedData['chainInfo']?.['chainUserMapping']})
                  }
                  const { chainId } = this.state;
                  this.props
                    .fetchChainUsers(chainId, {
                      page: 0,
                      size: USER_STORES_PAGE_SIZE,
                      sort: USER_STORES_DEFAULT_SORT,
                    })
                    .then(() => {
                      this.setState({ resetTable: true,chainId:-1 });
                      this.updateTableData();
                      this.handleResetDropdown();
                      this.reloadTable()
                      this.setState({
                        resetTable: false,
                        page: 0,
                        size: USER_STORES_PAGE_SIZE,
                        sort: USER_STORES_DEFAULT_SORT,
                      });
                    });
                }}
                onUploadError={this.handleUploadError}
              />
              <FileEditorModal
                isOpen={fileEditorOpen}
                file={fileEditorFile}
                error={fileEditorError}
                prefix="USER2STORE"
                config={{
                  prefix: "USER2STORE",
                  url: `${Config.API_SERVICE_URL}/api/users-stores`,
                  onUploadSuccess: this.handleFileEditorSuccess,
                }}
                onClose={this.handleFileEditorClose}
              />
            </div>
            <div className="upload-section-2">
              <h4>User Role Chain Mapping</h4>
              <div>
                <CSVDownload
                  data={[]}
                  headers={getTemplateHeaders(label)}
                  filename={buildExportFilename("csv", `${label}-template`)}
                >
                  <div className="file-upload-header">Download CSV Template</div>
                </CSVDownload>
              </div>

              <FileUpload
                prefix={"CHAINROLEUSER"}
                url={`${Config.API_SERVICE_URL}/api/chain-user-role`}
                label={""}
                dataQa={"chain-user-role-mapping-file-upload"}
                afterUploadFunction={() => {
                  const { chainId } = this.state;
                  this.props
                    .fetchChainUsers(chainId, {
                      page: 0,
                      size: USER_STORES_PAGE_SIZE,
                      sort: USER_STORES_DEFAULT_SORT,
                    })
                    .then(() => {
                      this.setState({ resetTable: true, chainId: -1 });
                      this.updateTableData();
                      this.handleResetDropdown();
                      this.reloadTable()
                      this.setState({
                        resetTable: false,
                        page: 0,
                        size: USER_STORES_PAGE_SIZE,
                        sort: USER_STORES_DEFAULT_SORT,
                      });
                    });
                }}
                onUploadError={this.handleUploadError2}
              />
              <FileEditorModal
                isOpen={fileEditorOpen2}
                file={fileEditorFile2}
                error={fileEditorError2}
                prefix="CHAINROLEUSER"
                config={{
                  prefix: "CHAINROLEUSER",
                  url: `${Config.API_SERVICE_URL}/api/chain-user-role`,
                  onUploadSuccess: this.handleFileEditorSuccess2,
                }}
                onClose={this.handleFileEditorClose2}
              />
            </div>
          </div>
          <CardList>
            <Card>
              <ManageDataPreview prefix={"USER2STORE"} label={"Store-User Mapping(s)"} />
            </Card>
          </CardList>
          <CardList>
            <Card>
              <ManageDataPreview prefix={"CHAINROLEUSER"} label={"Chain-User-Role Mapping(s)"} />
            </Card>
          </CardList>
          <div
            className="manage-data-table-controls"
            data-qa="chain-dropdown"
            style={{flexWrap: "wrap", gap: "12px"}}
          >
          <div style={{ position: "relative", pointerEvents: this.props.chainUserRoleLoader ? "none" : "auto", opacity: this.props.chainUserRoleLoader ? 0.5 : 1 }}>
            <ChainFilter
              onChange={({ id }) =>
                this.props
                  .fetchChainUsers({
                    chainId: id,
                    page: 0,
                    size: USER_STORES_PAGE_SIZE,
                    sort: USER_STORES_DEFAULT_SORT,
                  })
                  .then(() => {
                    this.setState({ chainId: id, resetTable: true });
                    this.updateTableData();
                    this.setState({
                      resetTable: false,
                      page: 0,
                      size: USER_STORES_PAGE_SIZE,
                      sort: USER_STORES_DEFAULT_SORT,
                    });
                  })
              }
              isSearchable
              resetFilter={this.state.resetChainFilter}
            />
          </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* Loader with spacing */}
              <div style={{ paddingTop: '0px', marginRight: '12px' }}>
                {this.state.isAwaitingCopy && (
                  <Loader height={20} width={20} custom={true} />
                )}
              </div>

              {/* Buttons group */}
              <div style={{ display: 'flex', gap: '12px', flexWrap: "wrap" }}>
                <button
                  onClick={this.handleDeleteAllChainRole}
                  style={{
                    padding: "6px 12px",
                    borderRadius: 4,
                    background: this.state.isAwaitingExport || (this.state.selectedRows.length === 0 && !this.state.selectAllActive) ? "#f5f5f5" : "#fff",
                    color: this.state.isAwaitingExport || (this.state.selectedRows.length === 0 && !this.state.selectAllActive) ? "#bbb" : "#E5B42F",
                    border: "1px solid #E5B42F",
                    cursor: this.state.isAwaitingExport || (this.state.selectedRows.length === 0 && !this.state.selectAllActive) ? "not-allowed" : "pointer",
                    opacity: this.state.isAwaitingExport || (this.state.selectedRows.length === 0 && !this.state.selectAllActive) ? 0.6 : 1,
                    fontSize:'14px'
                  }}
                  disabled={ this.state.isAwaitingExport || (this.state.selectedRows.length === 0 && !this.state.selectAllActive)}
                >
                  <img
                    src={deleteIcon}
                    alt="Export Icon"
                    width="16"
                    height="16"
                    style={{ marginRight: "6px" }}
                  />
                 Delete All
                </button>
                <button
                  onClick={this.handleCopyAllChainRole}
                  style={{
                    padding: "6px 12px",
                    borderRadius: 4,
                    background: this.state.isAwaitingCopy || this.state.selectedRows.length === 0|| this.state.selectedRows.length>10  ||
                    this.state.hasSameChainSelected? "#f5f5f5" : "#fff",
                    color: this.state.isAwaitingCopy || this.state.selectedRows.length === 0|| this.state.selectedRows.length>10 ||
                    this.state.hasSameChainSelected ? "#bbb" : "#E5B42F",
                    border: "1px solid #E5B42F",
                    cursor: this.state.isAwaitingCopy || this.state.selectedRows.length === 0 || this.state.selectedRows.length>10 ||
                    this.state.hasSameChainSelected? "not-allowed" : "pointer",
                    opacity: this.state.isAwaitingCopy || this.state.selectedRows.length === 0 || this.state.selectedRows.length>10 ||
                    this.state.hasSameChainSelected ? 0.6 : 1,
                  }}
                  disabled={ this.state.isAwaitingCopy || this.state.selectedRows.length === 0  || this.state.selectedRows.length>10 ||
                    this.state.hasSameChainSelected}
                >
                  <img
                    src={copyIcon}
                    alt="Export Icon"
                    width="16"
                    height="16"
                    style={{ marginRight: "6px" }}
                  />
                  Copy Store Assignment
                </button>
                <button
                  onClick={this.handleExportAllUserStores}
                  style={{
                    padding: "6px 12px",
                    borderRadius: 4,
                    background: "#fff",
                    color: "#E5B42F",
                    border: "1px solid #E5B42F",
                    cursor: "pointer",
                    fontSize:'14px'
                  }}
                  disabled={this.state.isAwaitingExportUserStores}
                >
                  {this.state.isAwaitingExportUserStores ? (
                    <AnimatedDownloadIcon size={16} style={{ marginRight: "6px" }} />
                  ) : (
                    <img
                      src={exportIcon}
                      alt="Export Icon"
                      width="16"
                      height="16"
                      style={{ marginRight: "6px" }}
                    />
                  )}
                  Export All User Store Mapping
                </button>

                <button
                  onClick={this.handleExportAllStoreMappings}
                  style={{
                    padding: "6px 12px",
                    borderRadius: 4,
                    background: "#fff",
                    color: "#E5B42F",
                    border: "1px solid #E5B42F",
                    cursor: "pointer",
                    fontSize:'14px'
                  }}
                  disabled={this.state.isAwaitingExportChainRoles}
                >
                  {this.state.isAwaitingExportChainRoles ? (
                    <AnimatedDownloadIcon size={16} style={{ marginRight: "6px" }} />
                  ) : (
                    <img
                      src={exportIcon}
                      alt="Export Icon"
                      width="16"
                      height="16"
                      style={{ marginRight: "6px" }}
                    />
                  )}
                  Export All User Role Chain Mapping
                </button>
                <button
                  onClick={this.displayCreateChainUserMapping}
                  style={{
                    // padding: "6px 12px",
                    // borderRadius: 4,
                    // background: "#fff",
                    // color: "#E5B42F",
                    // border: "1px solid #E5B42F",
                    // cursor: "pointer",
                    fontSize:'14px',
                    fontWeight: 500,
                  }}
                  className="primary-button"
                  disabled={this.state.isAwaitingExport}
                >
                <img
                  src={userIcon}
                  alt="User Icon"
                  width="16"
                  height="16"
                  style={{ marginRight: "6px", filter: "brightness(0) saturate(100%)" }}
                />
                  {/* Create User Role Chain Mapping */}
                  Add User to Chain
                </button>
              </div>
            </div>
          </div>

          <div>
            {exportedUserStores && exportedUserStores.length > 0 && (
              <CSVDownload2
                data={exportedUserStores}
                headers={this.CSV_HEADERS}
                filename={buildExportFilename("csv", "users-stores")}
              />
            )}
          </div>
          <div>
            {exportedChainUserRole && exportedChainUserRole.length > 0 && (
              <CSVDownload2
                data={exportedChainUserRole}
                headers={this.CSV_HEADERS2}
                filename={buildExportFilename("csv", "chain-users-role")}
              />
            )}
          </div>
          <div style={{display:"flex", justifyContent:"space-between", margin:"1%"}}>
            <div>
                {this.state.bulkDeleteMessage && (
                  <div style={{display:"flex", justifyContent:"space-between", marginBottom: 6}}>
                    <img src={INFORMATION_ERROR_ICON} alt="info" style={{ width: 22 }} />
                    <div style={{color:"#C0564B"}}>
                      {this.state.bulkDeleteMessage}
                    </div>
                  </div>
                )}
                {((this.state.selectedRows.length>10 || this.state.hasSameChainSelected) ||
                  (this.state.selectAllActive && totalCount && totalCount>1 )) && (
                 <div style={{display:"flex", justifyContent:"space-between"}}>
                      <img src={INFORMATION_ERROR_ICON} alt="info" style={{ width: 22 }} />
                   {(this.state.selectedRows.length>10 )|| (this.state.selectAllActive && totalCount && totalCount>10)  && (
                     <div style={{color:"#C0564B"}}>
                       Copy Store Assignment is available for up to only 10 source users.
                     </div>
                   )}
                   {(
                     this.state.hasSameChainSelected ||
                     (this.state.selectAllActive && this.state.chainId > -1 && totalCount && totalCount > 1 )
                   ) && (
                     <div style={{ color: "#C0564B", display: "row" }}>
                       Only one user per chain selection is allowed.
                     </div>
                   )}


                 </div>
                )}
            </div>

            <div style={{color:"#929497", fontSize:"12px", fontFamily:"poppins"}}>
              Selected {this.state.selectAllActive ? this.props.totalCount : this.state.selectedRows.length} Users
            </div>
          </div>
          <div className="api-table-body-wrapper manage-mapping-data" style={{margin:"1%"}}>
            {/* Replaced LightThemeTable with API-driven table (server-side search/sort/pagination) */}
            <ApiLightTable
              columns={columns}
              data={this.state.tableData}
              total={this.props.totalCount ?? 0}
              loading={this.props.chainUserRoleLoader}
              page={(this.props.currentPage ?? 0)}
              selectedRows={this.state.selectedRows}
              onRowSelect={this.handleRowSelect}
              selectAllActive={this.state.selectAllActive}
              onSelectAll={this.handleSelectAll}
              roles={this.state.dropdownOptions}
              pageSize={this.state.size ?? USER_STORES_PAGE_SIZE}
              onSearch={(field: string, value: string) => {
                this.setState(
                  (prevState) => ({
                    ...prevState,
                    page: 0,
                    [field]: value,
                  }),
                  () => {
                    const {
                      chainId,
                      size = USER_STORES_PAGE_SIZE,
                      sort,
                      email,
                      first_name,
                      last_name,
                      company,
                      chain_name,
                      role_name
                    } = this.state;

                    // Start building params
                    const params: any = {
                      chainId,
                      size,
                      sort,
                      page: 0,
                    };

                    // List of all searchable fields
                    const searchFields = {
                      email,
                      first_name,
                      last_name,
                      company,
                      chain_name,
                      role_name,
                    };

                    // Add ONLY fields that have non-empty values
                    Object.entries(searchFields).forEach(([key, val]) => {
                      if (val !== undefined && val !== null && val !== "") {
                        params[key] = val;
                      }
                    });

                    this.props.fetchChainUsers(params)
                      .then(() => this.updateTableData());
                  }
                );
              }}
              onSort={(field: string, order: "asc" | "desc") => {
                // Build final sort param
                const sortParam = `${field}.${order}`;

                this.setState(
                  (prevState) => ({
                    ...prevState,
                    page: 0, // reset pagination
                  }),
                  () => {
                    const { chainId, page = 0, size = USER_STORES_PAGE_SIZE } = this.state;

                    // Collect only non-empty search fields
                    const searchFields = {
                      email: this.state.email,
                      first_name: this.state.first_name,
                      last_name: this.state.last_name,
                      company: this.state.company,
                      chain_name: this.state.chain_name,
                      role_name: this.state.role_name,
                    };

                    const activeSearchFields: any = {};
                    Object.entries(searchFields).forEach(([key, value]) => {
                      if (value !== "" && value !== null && value !== undefined) {
                        activeSearchFields[key] = value;
                      }
                    });

                    // Final params – clean, no duplicates
                    const params: any = {
                      chainId,
                      page,
                      size,
                      sort: sortParam,
                      ...activeSearchFields,
                    };
                    this.setState({sort:sortParam})

                    this.props.fetchChainUsers(params).then(() => this.updateTableData());
                  }
                );
              }}
              clearSearch={this.state.clearSearchTrigger}
              onPageChange={(page1Based: number, size: number) => {
                const apiPage = Math.max(0, page1Based - 1);

                const {
                  chainId,
                  sort, // ← use the existing sort value from state
                } = this.state;

                // Only take non-empty search fields
                const searchFields = {
                  email: this.state.email,
                  first_name: this.state.first_name,
                  last_name: this.state.last_name,
                  company: this.state.company,
                  chain_name: this.state.chain_name,
                  role_name: this.state.role_name,
                };

                const activeSearchFields: any = {};
                Object.entries(searchFields).forEach(([key, value]) => {
                  if (value !== "" && value !== null && value !== undefined) {
                    activeSearchFields[key] = value;
                  }
                });

                const params: any = {
                  chainId,
                  page: apiPage,
                  size,
                  ...activeSearchFields,
                  ...(sort ? { sort } : {}), // keep active sort
                };
                this.setState({ page: apiPage, size });

                this.props.fetchChainUsers(params).then(() => this.updateTableData());
              }}

              onRowClick={(row: any) => {
                // optional: keep as no-op or open details
                // console.log("Row clicked", row);
              }}
            />
          </div>
          <div>
            <Modal
              show={this.state.showModal}
              onClose={() => this.setState({ showModal: false })}
              title={this.state.selectedUser["name"]}
              showToggle={true}
              toggleChecked={this.state.storeSelectAll}
              onToggleChange={(checked) => this.handleHeaderToggle(checked)}
              width="800px"
              height="400px"
              closeOnBackdropClick={false}
              footer={
                <div>
                    <div style={{ display: 'flex',justifyContent:"end" }}>
                      <div style={{  marginTop: '2%' }}>
                        {this.state.isAwaitingCreation && (<Loader height={20} width={20} custom={true} ></Loader>)}
                      </div>
                      <div style={{ margin: "1%" }}>
                        <button
                          onClick={this.handleGrantAccess}
                          style={{
                            padding: "6px 12px",
                            borderRadius: 4,
                            background: "#E5B42F",
                            color: "#0F0F0F",
                            border: "none",
                            cursor: "pointer",
                            minWidth: "250px",
                          }}
                        >
                          {this.state.isAwaitingCreation ? 'Submitting' : 'Grant access to all filtered stores'}
                        </button>
                      </div>
                    </div>

                </div>
              }
            >
              <div>
                <LightThemeTable
                  data={sortedStores}
                  columns={storeColumns}
                  tableHeight="300px"
                  showPagination={true}
                />
              </div>
            </Modal>
          </div>
          <div>
            <Modal
              show={this.state.showWarningModal}
              onClose={() => this.setState({ showWarningModal: false })}
              title=""
              width="400px"
              closeOnBackdropClick={false}
              footer={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                    paddingTop: 10,
                  }}
                >
                  <div style={{ width: '7%', paddingTop: '3px' }}>
                    {this.state.isAwaitingDelete && (<Loader height={20} width={20} custom={true} ></Loader>)}
                  </div>
                  <button
                    onClick={() => this.setState({ showWarningModal: false })}
                    style={{
                      padding: "6px 16px",
                      borderRadius: 4,
                      border: "1px solid light gray",
                      background: "transparent",
                      color: "#000",
                      cursor: "pointer",
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  >
                    Cancel
                  </button>
                  {this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() =>
                        this.setState({}, () => this.handleConfirm())
                      }
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                      disabled={this.state.isAwaitingDelete}
                    >
                      Yes, Continue
                    </button>
                  )}
                </div>
              }
            >
              <p style={{ marginBottom: 20, color: "#555", fontSize: 12 }}>
                <strong>{this.state.statusMessage}</strong>
              </p>
            </Modal>
          </div>
          <div>
            <CopyAssignmentModal
              show={this.state.copyChainAssigmentModal}
              onClose={() =>
                this.setState(prev => ({
                  copyChainAssigmentModal: false,
                  copySelectedRows: [],       // force clear
                  copyUserAssignInfo: [],
                  selectedRows: [],
                  rowMap: {},                 // clear rowMap so no stale rows remain
                  // if selectAllActive was true, reset it and clear hasSameChainSelected
                  selectAllActive: prev.selectAllActive ? false : prev.selectAllActive,
                  hasSameChainSelected: prev.selectAllActive ? false : prev.hasSameChainSelected,
                }))
              }
              title="Set Up Store Assignment Copy"
              subTitle="Review source users and resolve issues before copying store assignments."
              closeOnBackdropClick={false}
              width="1000px"
              footer={
                <React.Fragment key={this.state.isAwaitingCopy ? "loading" : "idle"}>
                <div  style={this.state.copyUsersErrorMsgs.length>0 ? { height: "50px", overflow: "auto" } : {}}>
                  {this.state.copyUsersErrorMsgs?.map((msg: string, i: number) => (
                    <div
                      key={i}
                      style={{
                        color: "#D32F2F",
                        fontSize: "12px",
                        marginBottom: "4px",
                      }}
                    >
                      • {msg}
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                    paddingTop: 10,
                  }}
                >
                  <div style={{ width: '7%', paddingTop: '3px' }}>
                    {this.state.isAwaitingCopy && (
                      <Loader height={20} width={20} custom={true} />
                    )}
                  </div>
                  <button
                    onClick={() =>
                      this.setState(prev => ({
                        copyChainAssigmentModal: false,
                        copySelectedRows: [],       // force clear
                        copyUserAssignInfo: [],
                        selectedRows: [],
                        rowMap: {},                 // clear rowMap so no stale rows remain
                        // if selectAllActive was true, reset it and clear hasSameChainSelected
                        selectAllActive: prev.selectAllActive ? false : prev.selectAllActive,
                        hasSameChainSelected: prev.selectAllActive ? false : prev.hasSameChainSelected,
                      }))
                    }
                    style={{
                      padding: "6px 16px",
                      borderRadius: 4,
                      border: "1px solid #E3AF32",
                      background: "transparent",
                      color: "#000",
                      cursor: "pointer",
                      fontSize: 12,
                      fontWeight: 500,
                    }}
                  >
                    Cancel
                  </button>
                  {this.state.isCopyContinueBtn && (
                    <button
                      onClick={() => {
                        this.setState({ isAwaitingCopy: true }, () => {
                          this.handleCopyStoreAssignment();
                        });
                      }}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: this.state.isAwaitingCopy || this.state.copyUserAssignInfo.length === 0 || this.state.copySelectedRows.length==0? "#f5f5f5" : "#E5B42F",
                        color: this.state.isAwaitingCopy || this.state.copyUserAssignInfo.length === 0 || this.state.copySelectedRows.length==0 ? "#bbb" : "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 500,
                      }}
                      disabled={this.state.isAwaitingCopy || this.state.copyUserAssignInfo.length==0 ||
                        this.state.copySelectedRows.length==0}
                    >
                      Continue
                    </button>
                  )}
                </div>
                </React.Fragment>
              }
            >
            <div className="copy-assignment-container">
              <div className="copy-assignment-source-container">
                <div className="container-info">
                  <p>Source Users</p>
                  <div style={{display:"flex", justifyContent:"space-between"}}>
                    <div className="sub-text-content">Only one user per chain is allowed.</div>
                    <div className="sub-text-content">Chains Selected {this.state.selectedRows.length}/10</div>
                  </div>
                  <div style={{height:"300px", overflow:"auto"}}>
                    {this.state.copySelectedRows.map((each:any,i)=>{
                      return (
                          <div key={i} className="copy-chain-list">
                            <div>{each?.chain_name}</div>
                            <div className="copy-store-name">
                              <span>{getFullName(each?.first_name, each?.last_name)}</span>
                              <div
                                onClick={()=>this.handleRowSelect(each)}
                                style={{
                                  background: "none",
                                  border: "none",
                                  fontSize: "24px",
                                  color: "#000000",
                                  cursor: "pointer",
                                  height:"21px",
                                  padding:"none !important",
                                  lineHeight:"25px"
                                }}
                              >
                                ×
                              </div>
                            </div>
                          </div>
                      );
                    })}
                  </div>

                </div>
              </div>
              <div className="copy-assignment-target-container">
                <div className="container-info">
                  <p>Target Users</p>
                  <div className="sub-text-content">Selected target users will receive the same store assignments.</div>
                </div>
                <div>
                  <div style={{margin:"12px 12px 12px 12px"}}>
                    <CopyUserFilter onChange={(u) => this.handleSwitchUser(u.user)} />
                  </div>
                  <div style={{height:"190px", overflow:"auto"}}>
                    {this.state.copyUserAssignInfo.map((eachUserInfo:any,i)=>{
                      return (
                        <div key={i}>
                          <div className="selected-user-info">
                            <span className="user-info">{getFullName(eachUserInfo?.firstname, eachUserInfo?.lastname)}</span>
                            <div
                               onClick={()=>this.removeUserSelect(eachUserInfo)}
                              style={{
                                background: "none",
                                border: "none",
                                fontSize: "24px",
                                color: "#000000",
                                cursor: "pointer",
                                height:"21px",
                                padding:"none !important",
                                lineHeight:"25px"
                              }}
                            >
                              ×
                            </div>
                          </div>

                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
            </CopyAssignmentModal>

            <CopyAssignmentModal
              show={this.state.isCreateChainRoleModal}
              onClose={() => this.setState({ isCreateChainRoleModal: false,formStatueErrMsg:"", selectedCreateChain:-1,
                selectedCreateRole:-1, selectedCreateEmail:"" })}
              title="Add User to Chain"
              // title="Create Chain User Role Mapping"
              subTitle=""
              closeOnBackdropClick={false}
              width="1000px"
              footer={
                <React.Fragment key={this.state.isAwaitingCopy ? "loading" : "idle"}>
                  {this.state.createChainUserMessage && (
                    <div>
                      {this.state.createChainUserMessage}
                    </div>
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 10,
                      paddingTop: 10,
                    }}
                  >
                    <div style={{ width: '7%', paddingTop: '3px' }}>
                      {this.state.isAwaitingCopy && (
                        <Loader height={20} width={20} custom={true} />
                      )}
                    </div>
                    <button
                      onClick={() => this.setState({ isCreateChainRoleModal: false,formStatueErrMsg:"", selectedCreateChain:-1,
                        selectedCreateRole:-1, selectedCreateEmail:"" })}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "1px solid #E3AF32",
                        background: "transparent",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 500,
                      }}
                    >
                      Cancel
                    </button>
                    {this.state.isCopyContinueBtn && (
                      <button
                        onClick={() => {
                          const isValid =
                            this.state.selectedCreateChain>=0 &&
                            this.state.selectedCreateRole>=0 &&
                            this.state.selectedCreateEmail.trim();
                          if (!isValid) {
                            this.setState({ createFormError: true });
                            return;
                          }
                          this.setState({ createFormError: false }, () => {
                            this.handleSaveChainUser();
                          });
                        }}
                        style={{
                          padding: "6px 16px",
                          borderRadius: 4,
                          border: "none",
                          background: this.state.isAwaitingCopy ? "#f5f5f5" : "#E5B42F",
                          color: this.state.isAwaitingCopy  ? "#bbb" : "#000",
                          cursor: "pointer",
                          fontSize: 12,
                          fontWeight: 500,
                        }}
                        disabled={this.state.isAwaitingCopy}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </React.Fragment>
              }
            >
              <div style={{display:"flex", flexDirection: isMobile ? "column" : "row", justifyContent:"space-between"}}>
                <div style={{width:"100%", margin:"1%"}}>
                  <label>
                    Chain<span style={{ color: "red" }}>*</span>
                  </label>
                  <ChainFilter
                    onChange={({ id }) =>{
                        this.setState({selectedCreateChain:id})
                    }}
                    isSearchable
                    resetFilter={this.state.isCreateChainFilter}
                  />
                  {this.state.createFormError && this.state.selectedCreateChain==-1 && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
                <div style={{width:"100%", margin:"1%"}}>
                  <label>
                    Role<span style={{ color: "red" }}>*</span>
                  </label>
                  <RoleFilter
                    options={this.state.dropdownOptions}
                    onChange={({ id }) =>{
                      this.setState({selectedCreateRole:id})
                    }}
                    isSearchable
                    reset={this.state.isResetRoleFilter}
                  />
                  {this.state.createFormError && this.state.selectedCreateRole==-1 && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
                <div style={{width:"100%", margin:"1%"}}>
                  <label>
                    Email Address<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    value={this.state.selectedCreateEmail}
                    onChange={this.handleEmailChange}
                    onBlur={this.handleEmailBlur}
                    placeholder="Enter Email Address"
                    style={{
                      ...styles2.input,
                      height: "44px",
                      border: "1px solid #ccc",
                      background:"#fff",
                    }}

                  />
                  {/* Show required field error */}
                  {this.state.createFormError && !this.state.selectedCreateEmail && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                  {/* Show invalid email error */}
                  {this.state.showEmailError && this.state.email && (
                    <span style={{ color: "red", fontSize: 12 }}>
                      Please enter a valid email address.
                    </span>
                  )}
                </div>
              </div>
              {this.state.formStatueErrMsg && (
                <div style={{ color: "red", fontSize: 12, marginLeft:"1%" }}>
                  {this.state.formStatueErrMsg}
                </div>
              )}
            </CopyAssignmentModal>

            <AddUsersNotFoundModal
              isOpen={this.state.isStoreUsersModal}
              isManagedData={true}
              closeOnBackdropClick={false}
              errors={this.state.storeUserErrors}
              users={this.state.storeUsersInfo}
              onSave={(usersWithRoles) => {
                this.handleSaveStoreChainUser(usersWithRoles)
              }}
              onNo={() => {
                this.setState({isStoreUsersModal:false})
              }}
              onClose={() => {
                this.setState({isStoreUsersModal:false})
              }}
            />
          </div>
        </div>
      </section>
      </>
    );
  }
}

const connecter = connect(
  (state: State) => ({
    chinsUserRoles: state.chains_users_role.content,
    exportContent: state.chains_users_role.exportContent,
    exportedUserStores: state.chains_users_role.exportChainUserContent,
    exportedChainUserRole: state.chains_users_role.exportChainUserRoleContent,
    loading: state.chains_users_role.loading,
    totalPages: state.chains_users_role.totalPages,
    totalCount: state.chains_users_role.totalCount,
    pageSize: state.chains_users_role.pageSize,
    page:state.chains_users_role.currentPage,
    currentPage: state.chains_users_role.currentPage,
    roles: state.chains_users_role.roles,
    chainUserRoleLoader:state.chains_users_role.chainRoleLoader,
    authUser: state.auth_user.content,
    copyAssignUser: state.chains_users_role.copyUserAssign,
    copyAssignUserError:state.chains_users_role.errorCopyUserAssignMessage,
    saveChainUserRole:state.chains_users_role.saveChainUserRoleFormReq,
    saveChainUserRoleErrorMsg:state.chains_users_role.saveChainUserErrorMessage,
    fileUploadedData:state[`USER2STORE_file_upload`],
    storeUserChainRoleError:state.chains_users_role.saveStoreUserError
  }),
  {
    //fetchUsersToStoresByChainId,
    // filterUsersToStoresByChainId,
    exportAllUserChainMapping,
    exportUsersStoresMapping,
    exportUsersToStoresByChainId,
    deleteUserToStore,
    deleteAllUserToStoreMappings,
    deleteUserToChainStoreMappings,
    fetchChainUsers,
    getRoles,
    updateUserChainRoleMapping,
    deleteChainUserRoleMapping,
    updateUserStoreMapping,
    deleteStoresToUser,
    deleteAllChainRoleMappings,
    copyStoreUserMapping,
    saveChainUserRoleFrom,
    saveStoreChainUserRole
  }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(ManageMappingData);
